<div class="main-content profile-editor-page inventario-ia-detalle-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>Detalle del activo IA</h1>
        <p>
          Vista de solo lectura (ISO/IEC 42001 · FDS-043)
          <span *ngIf="inventario?.consecutivo"> — Folio <strong>{{ inventario?.consecutivo }}</strong></span>
        </p>
      </div>
      <div class="profile-editor-page__hero-actions">
        <button type="button" class="app-form-btn app-form-btn--secondary" (click)="regresar()">Regresar</button>
        <button type="button" class="app-form-btn app-form-btn--primary" (click)="verHistorial()">
          <i class="material-icons">history</i> Historial
        </button>
      </div>
    </section>

    <div class="table-page__empty" *ngIf="loading">
      <i class="material-icons">hourglass_top</i><strong>Cargando…</strong>
    </div>

    <div class="table-page__empty" *ngIf="!loading && !inventario">
      <i class="material-icons">error_outline</i><strong>No se encontró el registro.</strong>
    </div>

    <ng-container *ngIf="!loading && inventario">
      <!-- Identificación -->
      <section class="profile-editor-page__card inventario-ia-detalle-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title"><i class="material-icons">smart_toy</i><span>Identificación</span></div>
        </div>
        <div class="profile-editor-page__card-body">
          <div class="detalle-grid">
            <div class="detalle-item"><span>Nombre del sistema</span><strong>{{ inventario.nombreIa || "—" }}</strong></div>
            <div class="detalle-item"><span>Versión</span><strong>{{ inventario.version || "—" }}</strong></div>
            <div class="detalle-item"><span>Folio</span><strong>{{ inventario.consecutivo || "—" }}</strong></div>
            <div class="detalle-item"><span>Estatus</span>
              <strong><span class="table-page__status-badge" [ngClass]="inventario.estatus === 'ACTIVO' ? 'is-active' : 'is-inactive'">{{ inventario.estatus }}</span></strong>
            </div>
            <div class="detalle-item detalle-item--full"><span>Propósito</span><strong>{{ inventario.proposito || "—" }}</strong></div>
            <div class="detalle-item detalle-item--full"><span>Uso previsto</span><strong>{{ inventario.usoPrevisto || "—" }}</strong></div>
          </div>
        </div>
      </section>

      <!-- Propietario y ciclo -->
      <section class="profile-editor-page__card inventario-ia-detalle-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title"><i class="material-icons">timeline</i><span>Propietario y ciclo de vida</span></div>
        </div>
        <div class="profile-editor-page__card-body">
          <div class="detalle-grid">
            <div class="detalle-item"><span>Propietario</span><strong>{{ propietario }}</strong></div>
            <div class="detalle-item"><span>Etapa del ciclo de vida</span><strong>{{ inventario.cicloVidaNombre || "—" }}</strong></div>
            <div class="detalle-item"><span>Nivel de supervisión humana</span><strong>{{ inventario.nivelSupervisionNombre || "—" }}</strong></div>
            <div class="detalle-item"><span>Ubicación</span><strong>{{ inventario.ubicacion || "—" }}</strong></div>
            <div class="detalle-item"><span>Fecha alta</span><strong>{{ inventario.fechaAlta ? (inventario.fechaAlta | date: "dd/MM/yyyy") : "—" }}</strong></div>
            <div class="detalle-item"><span>Fecha baja</span><strong>{{ inventario.fechaBaja ? (inventario.fechaBaja | date: "dd/MM/yyyy") : "—" }}</strong></div>
          </div>
        </div>
      </section>

      <!-- Recursos -->
      <section class="profile-editor-page__card inventario-ia-detalle-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title"><i class="material-icons">settings_input_component</i><span>Recursos</span></div>
        </div>
        <div class="profile-editor-page__card-body">
          <div class="detalle-grid">
            <div class="detalle-item detalle-item--full"><span>Componentes del sistema de IA</span><strong>{{ inventario.componentesSistema || "—" }}</strong></div>
            <div class="detalle-item detalle-item--full"><span>Datos</span><strong>{{ inventario.componentesDatos || "—" }}</strong></div>
            <div class="detalle-item detalle-item--full"><span>Herramientas de IA</span><strong>{{ inventario.herramientasIa || "—" }}</strong></div>
            <div class="detalle-item detalle-item--full"><span>Sistemas y recursos informáticos</span><strong>{{ inventario.sistemasInformaticos || "—" }}</strong></div>
            <div class="detalle-item detalle-item--full"><span>Recursos humanos / roles</span><strong>{{ inventario.recursosHumanos || "—" }}</strong></div>
            <div class="detalle-item detalle-item--full"><span>Procesos en los que interviene</span><strong>{{ inventario.procesosIntervencion || "—" }}</strong></div>
          </div>
        </div>
      </section>

      <!-- Impactos -->
      <section class="profile-editor-page__card inventario-ia-detalle-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title"><i class="material-icons">analytics</i><span>Impactos identificados</span></div>
        </div>
        <div class="profile-editor-page__card-body">
          <div class="table-page__table-wrap" *ngIf="inventario.impactos && inventario.impactos.length > 0; else sinImpactos">
            <table class="table-page__table">
              <thead><tr><th>Tipo de impacto</th><th>Impacto positivo</th><th>Impacto negativo</th></tr></thead>
              <tbody>
                <tr *ngFor="let imp of inventario.impactos">
                  <td><strong class="table-page__name">{{ imp.tipoImpactoNombre || "—" }}</strong></td>
                  <td><span class="table-page__text">{{ imp.descripcionPositivo || "—" }}</span></td>
                  <td><span class="table-page__text">{{ imp.descripcionNegativo || "—" }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #sinImpactos>
            <div class="table-page__empty-state"><i class="material-icons">analytics</i><p>Sin impactos registrados.</p></div>
          </ng-template>
        </div>
      </section>
    </ng-container>
  </div>
</div>
